import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';

var root_2 = $.from_svg(`<svg class="check-icon svelte-wm7c29qap0uj" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"></path></svg>`);
var root_1 = $.from_html(`<button><!> <span class="side-label svelte-wm7c29qap0uj"> </span></button>`);
var root = $.from_html(`<div class="breast-picker svelte-wm7c29qap0uj"></div>`);

function BreastPicker($$anchor, $$props) {
	$.push($$props, true);

	const sides = [
		{ value: 'left', label: 'Left' },
		{ value: 'right', label: 'Right' },
		{ value: 'both', label: 'Both' }
	];

	var div = root();

	$.each(div, 21, () => sides, $.index, ($$anchor, side) => {
		var button = root_1();
		let classes;
		var node = $.child(button);

		{
			var consequent = ($$anchor) => {
				var svg = root_2();

				$.append($$anchor, svg);
			};

			$.if(node, ($$render) => {
				if ($$props.selected === $.get(side).value) $$render(consequent);
			});
		}

		var span = $.sibling(node, 2);
		var text = $.child(span, true);

		$.reset(span);
		$.reset(button);

		$.template_effect(() => {
			classes = $.set_class(button, 1, 'side-btn svelte-wm7c29qap0uj', null, classes, {
				active: $$props.selected === $.get(side).value,
				suggested: !$$props.selected && $$props.suggested === $.get(side).value
			});

			$.set_text(text, $.get(side).label);
		});

		$.delegated('click', button, () => $$props.onselect($.get(side).value));
		$.append($$anchor, button);
	});

	$.reset(div);
	$.append($$anchor, div);
	$.pop();
}

if (import.meta.hot) {
	BreastPicker = $.hmr(BreastPicker);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-wm7c29qap0uj');
		BreastPicker[$.HMR].update(module.default);
	});
}

export default BreastPicker;

$.delegate(['click']);
import "bun-svelte:BreastPicker.svelte-2mvnhg229ci9c-style.css";